import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ParksTabPageView } from './ParksTabPageView';

export function ParksTabPageContainer() {
  const { orgId } = useParams<{ orgId: string }>();
  const { t } = useTranslation('organization');

  return <ParksTabPageView title={t('title', { orgId })} />;
}
